import { authFetch } from '../utils/AuthFetch';

export const initiatePayment = async (payload: { reservationId: string; amount: number; method: string }) => {
    try {
      const response = await fetch('/api/payment/initiate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
  
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || 'Failed to initiate payment');
      }
  
      return await response.json(); 
    } catch (error) {
      console.error('Error initiating payment:', error);
      throw error;
    }
  };

  export const fetchPaymentStatus = async (paymentId: string) => {
    try {
      const response = await fetch(`/api/payment/${paymentId}/status`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
  
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || 'Failed to fetch payment status');
      }
  
      return await response.json(); // e.g., { status: "...", paidAmount: 10000, etc. }
    } catch (error) {
      console.error('Error fetching payment status:', error);
      throw error;
    }
  };
  
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';

  export const confirmPayment = async (data: {
    reservationId: string;
    paymentId: string;
    method: string;
    amount: number;
  }): Promise<void> => {
    try {
      const response = await fetch(`${API_BASE_URL}/payment/confirm`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to confirm payment');
      }
  
      return await response.json();
    } catch (error: any) {
      throw new Error(error.message || 'Failed to confirm payment');
    }
  };

export const cancelPayment = async (data : {
  reservationId: string;
  paymentId: string;
}) => {
  try {
    const response = await fetch(`${API_BASE_URL}/payment/cancle`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to confirm payment');
    }

    return await response.json();
  } catch (error: any) {
    throw new Error(error.message || 'Failed to confirm payment');
  }
};

export const getPaymentByOrderId = async (orderId: string) => {
  try {
    const response = await fetch(`${API_BASE_URL}/payment/${orderId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch payment by order ID');
    }

    const result = await response.json()
    return result.body.payment;
  } catch (error: any) {
    throw new Error(error.message || 'Failed to fetch payment by order ID');
  }
};

export async function getUserPaymentHistory() {
  const token = localStorage.getItem('user_token');

  const response = await fetch(`${API_BASE_URL}/payment/user/lists`, {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        },
    });
  const data = await response.json();
  return data.body.payment || [];
}